<div class="p-4 overflow-x-auto">
  <table mat-table [dataSource]="dataSource" class="w-full min-w-[500px] mat-elevation-z mt-3">
    <!-- Tipo de Pago -->
    <ng-container matColumnDef="paymentMethod">
      <th mat-header-cell *matHeaderCellDef class="px-6 text-left table-tittle">Tipo Pago</th>
      <td mat-cell *matCellDef="let method" class="px-6 text-left table-text">
        <p class="table-text-m">{{ method.paymentType?.name }}</p>
      </td>
      <!-- Footer -->
      <td mat-footer-cell *matFooterCellDef class="px-6 text-left font-bold">
        Totales:
      </td>
    </ng-container>

    <ng-container matColumnDef="payingCredit">
      <th mat-header-cell *matHeaderCellDef class="px-6 text-right table-tittle">
        Recibido ({{ 'code' | companyCurrency }})
      </th>
      <td mat-cell *matCellDef="let method" class="px-6 text-right table-text">
        {{ method.paying | decimalFormat }}
      </td>
      <!-- Footer -->
      <td mat-footer-cell *matFooterCellDef class="px-6 text-right font-bold">
        {{ totalPaying | decimalFormat }}
      </td>
    </ng-container>

    <ng-container matColumnDef="commission">
      <th mat-header-cell *matHeaderCellDef class="px-6 text-right table-tittle">Comisión ({{ 'code' | companyCurrency }})</th>
      <td mat-cell *matCellDef="let method" class="px-6 text-right table-text">
        <p class="table-text-m">{{ method.commission | decimalFormat }}</p>
      </td>
      <td mat-footer-cell *matFooterCellDef class="px-6 text-right font-bold">
        {{ totalCommission | decimalFormat }}
      </td>
    </ng-container>

    <ng-container matColumnDef="taxRetainment">
      <th mat-header-cell *matHeaderCellDef class="px-6 text-right table-tittle">Retención ({{ 'code' | companyCurrency }})</th>
      <td mat-cell *matCellDef="let method" class="px-6 text-right table-text">
        <p class="table-text-m">{{ method.taxRetainment | decimalFormat }}</p>
      </td>
      <td mat-footer-cell *matFooterCellDef class="px-6 text-right font-bold">
        {{ totalRetainment | decimalFormat }}
      </td>
    </ng-container>

    <ng-container matColumnDef="payingSCR">
      <th mat-header-cell *matHeaderCellDef class="px-6 text-right table-tittle">Ingreso ({{ 'code' | companyCurrency }})</th>
      <td mat-cell *matCellDef="let method" class="px-6 text-right table-text">
        <p class="table-text-m">{{ method.payingSCR | decimalFormat }}</p>
      </td>
      <td mat-footer-cell *matFooterCellDef class="px-6 text-right font-bold">
        {{ totalSCR | decimalFormat }}
      </td>
    </ng-container>

    <!--Total Extra Pago -->
    <ng-container matColumnDef="extraPaymentTotal">
      <th mat-header-cell *matHeaderCellDef class="px-6 text-right table-tittle">Total Sobrepago({{ 'code' | companyCurrency }})</th>
      <td mat-cell *matCellDef="let method" class="px-6 text-right table-text">{{ method.overpayment | decimalFormat }}</td>
      <td mat-footer-cell *matFooterCellDef class="px-6 text-right font-bold">{{ totalExtraPayment | decimalFormat }}</td>
    </ng-container>
    <!-- Comisión Extra Pago -->
    <ng-container matColumnDef="extraPaymentFee">
      <th mat-header-cell *matHeaderCellDef class="px-6 text-right table-tittle"> Comisión Sobrepago ({{ 'code' | companyCurrency }}) </th>
      <td mat-cell *matCellDef="let method" class="px-6 text-right table-text"> {{ method.overCommission | decimalFormat }} </td>
      <td mat-footer-cell *matFooterCellDef class="px-6 text-right font-bold"> {{ totalExtraCommission | decimalFormat }} </td>
    </ng-container>
    <!-- Banco -->
    <ng-container matColumnDef="bank">
      <th mat-header-cell *matHeaderCellDef class="px-6 text-left table-tittle">Nro. Nota Crédito</th>
      <td mat-cell *matCellDef="let method" class="px-6 text-left table-text">
        {{ method?.creditNoteNumber }}
      </td>
      <!-- Footer vacío para mantener la estructura -->
      <td mat-footer-cell *matFooterCellDef class="px-6 text-left"></td>
    </ng-container>

    <!-- Numero de Operacion -->
    <ng-container matColumnDef="operationNumber">
      <th mat-header-cell *matHeaderCellDef class="px-6 text-center table-tittle">Nro. Operación</th>
      <td mat-cell *matCellDef="let method" class="px-6 text-center table-text">
        {{ method?.operationNumber|| '-' }}
      </td>
      <!-- Footer vacío para mantener la estructura -->
      <td mat-footer-cell *matFooterCellDef class="px-6 text-center"></td>
    </ng-container>

        <!-- Cuenta -->
    <ng-container matColumnDef="accountNumber">
      <th mat-header-cell *matHeaderCellDef class="px-6 text-center table-tittle">Cuenta</th>
      <td mat-cell *matCellDef="let method" class="px-6 text-center table-text">
        {{ method?.account?.accountNumber || '-' }}
      </td>
      <!-- Footer vacío para mantener la estructura -->
      <td mat-footer-cell *matFooterCellDef class="px-6 text-center"></td>
    </ng-container>


    <!-- Abono -->
    <ng-container matColumnDef="paying">
      <th mat-header-cell *matHeaderCellDef class="px-6 text-right table-tittle">
        Abono ({{ 'code' | companyCurrency }})
      </th>
      <td mat-cell *matCellDef="let method" class="px-6 text-right table-text">
        {{ method.paying | decimalFormat }}
      </td>
      <!-- Footer con el total -->
      <td mat-footer-cell *matFooterCellDef class="px-6 text-right font-bold">
        {{ totalPaying | decimalFormat }}
      </td>
    </ng-container>

    <!-- Encabezado -->
    <tr mat-header-row *matHeaderRowDef="displayedColumns" class="bg-gray-100 dark:bg-gray-900"></tr>
    <!-- Filas de datos -->
    <tr mat-row *matRowDef="let row; columns: displayedColumns" class="border-b h-12"></tr>
    <tr mat-footer-row *matFooterRowDef="displayedColumns"></tr>

  </table>
</div>

<mat-dialog-actions class="modal-actions flex justify-between">
  <button mat-button mat-dialog-close>Cerrar</button>
</mat-dialog-actions>